import { ShieldCheck, Trees, FileText, FileSearch, CreditCard, Clock } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface StepHeaderConfig {
  icon: LucideIcon;
  iconBg: string;
  iconColor: string;
  headline: string;
  description: string;
}

export function getStepHeader(
  step: string,
  role: "seller" | "buyer",
  dealStatus?: string
): StepHeaderConfig | null {
  switch (step) {
    case "identity_verification":
      return role === "buyer"
        ? {
            icon: ShieldCheck,
            iconBg: "bg-blue-50",
            iconColor: "text-blue-600",
            headline: "Vertragsadresse",
            description:
              "Bitte hinterlegen Sie Ihre Vertragsadresse und die Daten des Unterzeichners. Diese werden für den Kaufvertrag verwendet.",
          }
        : {
            icon: ShieldCheck,
            iconBg: "bg-blue-50",
            iconColor: "text-blue-600",
            headline: "Identitätsprüfung",
            description:
              "Bitte laden Sie eine Kopie Ihres Personalausweises hoch und hinterlegen Sie Ihre Vertragsadresse. Unser Team prüft Ihre Identität in der Regel innerhalb von 1–2 Werktagen.",
          };
    case "eco_account_verification":
      return role === "buyer"
        ? {
            icon: Trees,
            iconBg: "bg-primary/10",
            iconColor: "text-primary",
            headline: "Ökokonto wird geprüft",
            description:
              "Wir prüfen das Ökokonto des Verkäufers, um sicherzustellen, dass die Punkte verfügbar sind. Sobald die Prüfung abgeschlossen ist, geht es mit dem Vertrag weiter.",
          }
        : {
            icon: Trees,
            iconBg: "bg-primary/10",
            iconColor: "text-primary",
            headline: "Ökokonto verifizieren",
            description:
              "Bitte laden Sie Ihr Ökokonto-Dokument hoch, damit unser Team die Angaben prüfen kann. Nach erfolgreicher Verifizierung geht es mit dem Vertrag weiter.",
          };
    case "contract_preparation":
      if (dealStatus === "contract_review") {
        return {
          icon: FileSearch,
          iconBg: "bg-violet-50",
          iconColor: "text-violet-600",
          headline: "Vertragsentwurf prüfen",
          description:
            "Prüfen Sie den Vertragsentwurf und geben Sie Ihr Einverständnis. Nach Zustimmung beider Parteien wird der Vertrag zur Unterschrift vorbereitet.",
        };
      }
      return {
        icon: Clock,
        iconBg: "bg-amber-50",
        iconColor: "text-amber-600",
        headline: "Vertrag wird vorbereitet",
        description:
          "Unser Team bereitet den Kaufvertrag für Sie vor. Sobald der Vertrag fertig ist, werden Sie benachrichtigt.",
      };
    case "contract":
      return {
        icon: FileText,
        iconBg: "bg-indigo-50",
        iconColor: "text-indigo-600",
        headline: "Vertrag & Unterschrift",
        description: "Prüfen Sie den Vertragsentwurf und unterschreiben Sie den Kaufvertrag.",
      };
    case "payment_pending":
      return role === "buyer"
        ? {
            icon: CreditCard,
            iconBg: "bg-amber-50",
            iconColor: "text-amber-600",
            headline: "Zahlung überweisen",
            description:
              "Bitte überweisen Sie den Kaufpreis gemäß Vertrag an den Verkäufer und die Provision gemäß Rechnung an die Plattform. Die Details finden Sie unten.",
          }
        : {
            icon: CreditCard,
            iconBg: "bg-amber-50",
            iconColor: "text-amber-600",
            headline: "Zahlungseingang bestätigen",
            description:
              "Bitte bestätigen Sie den Eingang der Zahlung vom Käufer, sobald diese auf Ihrem Konto eingegangen ist.",
          };
    default:
      return null;
  }
}
